import React from 'react';
import {CardActions, CreateButton, Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {
    BillAuthStatusField,
    DateTimeField,
    DownloadFileContentButton,
    EditButtonWithAuthStatus,
    HocKiField
} from "../../components";
import DownloadTemplateFileButtonV2 from "../../components/DownloadTemplateFileButtonV2";

const CustomerSubjectResultBatchFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         displayedFilters,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {/* Add your custom actions */}
        <DownloadTemplateFileButtonV2 basePath="/files/templates/mau_ket_qua_c1.zip"
                                      btnLabel="resources.customerSubjectResultBatchV2s.templateC1"/>
        <DownloadTemplateFileButtonV2 basePath="/files/templates/mau_ket_qua_c2.zip"
                                      btnLabel="resources.customerSubjectResultBatchV2s.templateC2"/>
        <DownloadTemplateFileButtonV2 basePath="/files/templates/mau_ket_qua_c3.zip"
                                      btnLabel="resources.customerSubjectResultBatchV2s.templateC3"/>
        <CreateButton basePath={basePath}/>
    </CardActions>
);

export const CustomerSubjectResultBatchList = props => (
    <List filters={<CustomerSubjectResultBatchFilter/>} {...props} actions={<PostActions/>} bulkActionButtons={false}>
        <Datagrid>
            <TextField source="id"/>
            <HocKiField source="hocKi"/>
            <TextField source="description"/>
            <DateTimeField source="lastUpdatedOn" format="DD-MM-YYYY HH:mm" width={'7%'}/>
            <TextField source="lastUpdatedBy"/>
            <BillAuthStatusField source="authStatus"/>
            <DownloadFileContentButton extension={".zip"}/>
            <EditButtonWithAuthStatus/>
        </Datagrid>
    </List>
);

export default CustomerSubjectResultBatchList
